import { CheckCircle2, AlertCircle, MessageSquare, X } from "lucide-react";
import { create } from "zustand";

type Toast = { id: number; tone: "success" | "error" | "info"; message: string };
type ToastState = { toasts: Toast[]; push: (t: Omit<Toast, "id">) => void; dismiss: (id: number) => void };

let seq = 0;
export const useToasts = create<ToastState>((set) => ({
  toasts: [],
  push: (t) => {
    const id = ++seq;
    set((s) => ({ toasts: [...s.toasts.slice(-3), { ...t, id }] }));
    setTimeout(() => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })), 5000);
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((x) => x.id !== id) })),
}));

/** Only call after the server has confirmed the operation. */
export const toast = {
  success: (message: string) => useToasts.getState().push({ tone: "success", message }),
  error: (message: string) => useToasts.getState().push({ tone: "error", message }),
  info: (message: string) => useToasts.getState().push({ tone: "info", message }),
};

export function Toaster() {
  const { toasts, dismiss } = useToasts();
  return (
    <div aria-live="polite" className="pointer-events-none fixed bottom-4 left-1/2 z-[60] flex w-[calc(100vw-2rem)] max-w-sm -translate-x-1/2 flex-col gap-2 sm:left-auto sm:right-4 sm:translate-x-0">
      {toasts.map((t) => (
        <div key={t.id} role={t.tone === "error" ? "alert" : "status"} className="glass pointer-events-auto flex animate-float-in items-start gap-2 rounded-2xl p-3 text-sm">
          {t.tone === "success" ? <CheckCircle2 className="h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" />
            : t.tone === "info" ? <MessageSquare className="h-4 w-4 shrink-0 text-accent-600" aria-hidden="true" />
            : <AlertCircle className="h-4 w-4 shrink-0 text-red-600" aria-hidden="true" />}
          <span className="flex-1 text-default">{t.message}</span>
          <button className="focus-ring rounded text-subtle" onClick={() => dismiss(t.id)} aria-label="Dismiss notification"><X className="h-4 w-4" /></button>
        </div>
      ))}
    </div>
  );
}
